<template>
  <div id="login">
    <div class="contentcenter" style="padding-top: 8%;justify-content: center;align-items: center;">
      <!--<img class="radarclass" src="../assets/img/login_logo.png"/>-->
      <div class="radarclass">国合基地信息采集系统</div>

      <div class="loginborder">
        <div class="maintitleclass1" style="width:100%;text-align:center;margin-top: 45px;">用户登录</div>
        <input style="margin-top: 30px" class="userId mainbordercontent2" v-model="userId" placeholder="账号"/>
        <input class="pwd mainbordercontent2" type="password"  v-model="pwd"  placeholder="密码"/>
        <div class="forgetclass displayflex-row" style="align-items: center;">
          <img @click="imgclick()" :src="remember?select:noselect"/>
          <div class="remember">记住密码</div>
        </div>
        <el-button
          type="primary"
          size="medium"
          class="loginclass"
          @click="loginclick"
          :loading="loading"
        >登 录</el-button>
        <div class="tipsclass">温馨提示：使用IE10及以上、谷歌、 火狐浏览器
          将提升您系统的使用体验</div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import * as api from "../utils/api"
  import select from "../assets/img/select.png"
  import noselect from "../assets/img/noselect.png"
  export default {
    data(){
      return {
        noselect,
        select,
        userId:'',//4
        pwd:'',//1
        loading:false,
        remember:false,

      }
    },
    mounted(){
      this.auto_set();

    },
    methods:{
      imgclick(){
        this.remember=!this.remember;
      },
      // 展示之前记住的帐号密码
      auto_set() {
        this.userId = LocalStorage.get('datacollect_userId')?LocalStorage.get('datacollect_userId'):this.userId;
        this.pwd = LocalStorage.get('datacollect_pwd')?LocalStorage.get('datacollect_pwd'):this.pwd;
        this.remember = LocalStorage.get('datacollect_remember')? LocalStorage.get('datacollect_remember'):this.remember;
      },
      loginclick() {

        // this.$router.push({ path: 'datacollectionlist'})
        //
        // return;
        var self = this;
        if (this.userId == '' || this.pwd == '') {
          this.$message.error('用户名或密码不能为空')
          return
        }
        self.loading=true;

        api.login({

          userId:this.userId,
          pwd:this.pwd,
        })
          .then(rs => {
            // console.log(rs)
            if(rs.status==200){
              LocalStorage.del('datacollect_remember');
              LocalStorage.del('datacollect_userId');
              LocalStorage.del('datacollect_token');
              LocalStorage.del('datacollect_userName');

              LocalStorage.set('datacollect_remember', self.remember)
              LocalStorage.set('datacollect_userId', rs.data.userId)
              LocalStorage.set('datacollect_userName',rs.data.userName)
              LocalStorage.set('datacollect_token', rs.data.token)

              if (self.remember) {
                LocalStorage.set('datacollect_pwd', self.pwd)
              } else {
                LocalStorage.set('datacollect_pwd', '')
              }
              self.getUserMenu(rs.data.formId,rs.data.collection)

              self.loading=false;

            }else{
              self.$message.error(rs.message)
              self.loading=false;

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })

      },

      getUserMenu(formId,collection){
        var self = this;
        self.loading=true;

        api.getUserMenu({})
          .then(rs => {
            if (rs.status == 200) {

              if(rs.data[0].collection=='home'){
                self.$router.replace({ name: 'home',query:{
                    formId:formId
                  }});
              }else {
                self.$router.replace({ name: collection,query:{
                    formId:formId
                  }});
              }

            } else {
              self.$message.error(rs.message)

            }
            self.loading=false;

          })
          .catch(err => {
            // self.$message.error(err)
            // self.loading=false;
            self.loading=false;

          })
      },

    },
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  #login {
    width: 100%;
    height:100%;
    /*min-width: 1920px;*/
    max-height: 1080px;
    min-height: 100vh;
    background-size: 100% 100%;
    /*max-height: 1080px;*/
    background-repeat: no-repeat;
    background: url("../assets/img/login_bg.png");
    background-position: 50% 50%;
    .contentcenter{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .radarclass{
      margin-bottom: 40px;
      font-size: 60px;
      color: #fff;
      letter-spacing: 5px;
      font-weight: bold;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }
    .loginborder{
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background: url("../assets/img/login_border.png");
      width: 460px;
      height: 468px;
      img{
        width: 24px;
        height: 24px;
        margin: 13px 20px;
      }
      input{
        background: transparent;
        border: 0;
        color:#fefefe;
        font-size: 16px;
        cursor: pointer;
        height: 50px;
        margin: 0px 40px 30px;
        width: calc(100% - 80px);
        box-sizing: border-box;
      }
      .tipsclass{
        color: #ffffff;
        font-size: 16px;
        padding: 0 40px;
        margin-top: 10px;
      }
      .userId{
        background:url("../assets/img/number.png") no-repeat scroll left center transparent;
        background-position: 8%;
        padding:0 15%;
      }
      .pwd{
        background:url("../assets/img/password.png") no-repeat scroll left center transparent;
        background-position: 8%;
        padding:0 15%;
        margin-bottom: 20px;

      }
      input:focus{
        border: solid 1px #09d7ed;
        color: #09d7ed;

      }

      .forgetclass{
        width: 380px;
        margin: 0px auto 10px;
        height: 40px;
        .remember{
          line-height: 40px;
          font-size: 18px;
          color: #ffffff;
          margin-left: 10px;
          cursor: pointer;
        }
        img{
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
      .loginclass{
        width: 380px;
        height: 50px;
        margin-top: 20px;
        margin-left: 40px;
        background-image: linear-gradient(0deg,
        #2d77f3 0%,
        #21e7ff 100%),
        linear-gradient(
          #4fe3c1,
          #4fe3c1);
        background-blend-mode: normal,
        normal;
        border-radius: 6px;
        text-align: center;
        color: #fefefe;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }

  ::-webkit-input-placeholder { color:#fefefe; font-size: 16px;}

  ::-moz-placeholder { color:#fefefe;font-size: 16px; } /* firefox 19+ */

  :-ms-input-placeholder { color:#fefefe; font-size: 16px;} /* ie */

  input:-moz-placeholder { color:#fefefe;font-size: 16px; }
  input:focus {
    outline-offset: 0;
  }
  :focus {
    outline: -webkit-focus-ring-color auto 0px;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:active,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:hover {
    -webkit-transition-delay: 999999s !important;
    transition-delay: 999999s !important;
    -webkit-transition: color 999999s ease-out, background-color 999999s ease-out !important;
    transition: color 999999s ease-out, background-color 999999s ease-out !important;
    -webkit-text-fill-color: #fefefe;
  }
  /*input:-internal-autofill-selected {*/
  /*background-color: transparent !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/Login.vue